/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../../streaming/offlinepayments/offline_payments_merchant_default';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "SetOfflinePaymentsMerchantDefaultRequest": {
                        "fields": {
                          "defaultOn": {
                            "type": "bool",
                            "id": 1,
                            "rule": "optional"
                          },
                          "merchantToken": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "enablementType": {
                            "type": ".squareup.devicesettings.streaming.offlinepayments.OfflinePaymentsEnablementType",
                            "id": 3,
                            "rule": "optional"
                          }
                        }
                      },
                      "SetOfflinePaymentsMerchantDefaultResponse": {
                        "fields": {}
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SetOfflinePaymentsMerchantDefaultRequest && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.SetOfflinePaymentsMerchantDefaultResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SetOfflinePaymentsMerchantDefaultRequest @ squareup/devicesettings/profiles/v2/message/set_offline_payments_merchant_default.proto at 10:1
 */
export const SetOfflinePaymentsMerchantDefaultRequest = $root.lookupType('squareup.devicesettings.profiles.v2.message.SetOfflinePaymentsMerchantDefaultRequest');
fixType(SetOfflinePaymentsMerchantDefaultRequest);
Builder.createAndAttachToType(SetOfflinePaymentsMerchantDefaultRequest);
/**
 * SOURCE SetOfflinePaymentsMerchantDefaultResponse @ squareup/devicesettings/profiles/v2/message/set_offline_payments_merchant_default.proto at 18:1
 */
export const SetOfflinePaymentsMerchantDefaultResponse = $root.lookupType('squareup.devicesettings.profiles.v2.message.SetOfflinePaymentsMerchantDefaultResponse');
fixType(SetOfflinePaymentsMerchantDefaultResponse);
Builder.createAndAttachToType(SetOfflinePaymentsMerchantDefaultResponse);